// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1QCt7","signatureButtonsRight":"ModalSign_signatureButtonsRight__1W6cN"};